export const formatAmount = (value, decimals) => {
  if (value === null || value === undefined || value === "") {
    return value;
  }

  const number = Number(value);

  if (!Number.isFinite(number)) {
    return value;
  }

  return number.toLocaleString(
    "en-US",
    decimals === undefined
      ? { maximumFractionDigits: 2 }
      : {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        },
  );
};

export const withCommas = (value) => {
  const text = String(value ?? "");
  const [whole, fraction] = text.split(".");
  const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return fraction !== undefined ? `${grouped}.${fraction}` : grouped;
};

export const cleanMoneyInput = (value) => {
  let text = String(value ?? "")
    .replace(/,/g, "")
    .replace(/[^\d.]/g, "");

  const dot = text.indexOf(".");

  if (dot !== -1) {
    text =
      text.slice(0, dot + 1) +
      text.slice(dot + 1).replace(/\./g, "").slice(0, 2);
  }

  return text.replace(/^0+(?=\d)/, "");
};
